import { Navigate, Outlet } from 'react-router-dom';
import { AuthService } from '../services/authService';
import { ROUTES } from './constants';

const PublicRoutes = () => {
  const isAuthenticated = AuthService.isAuthenticated();

  if (isAuthenticated) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
};

export default PublicRoutes;
